import { render, staticRenderFns } from "./AppContrapartidaField.vue?vue&type=template&id=73fe1a60&scoped=true&"
import script from "./AppContrapartidaField.vue?vue&type=script&lang=js&"
export * from "./AppContrapartidaField.vue?vue&type=script&lang=js&"
import style0 from "./AppContrapartidaField.vue?vue&type=style&index=0&id=73fe1a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fe1a60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
